import { useFormik } from "formik";
import { loginValidationSchema } from '../../../lib/validations/login-validation';
import { useLogin } from '../../../apis/auth/login';
import { useWhoAmI } from '../../../apis/auth/who-am-i';
import { deleteSessionCookie, setSessionCookie } from '../../../utils/cookies';
import { useAppDispatch } from '../../../Redux/store';
import { useNavigate } from 'react-router-dom';
import { login } from '../../../Redux/slices/auth';
import { toast } from 'react-toastify';

export const useLoginForm = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { mutateAsync: loginMutation, isPending } = useLogin();
    const { refetch: whoAmI } = useWhoAmI();

    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema: loginValidationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const res = await loginMutation({
                    email: values.email.trim(),
                    password: values.password,
                });


                console.log("Login response:", res);

                setSessionCookie("accessToken", res.accessToken);
                setSessionCookie("refreshToken", res.refreshToken);

                const { data: user } = await whoAmI();

                if (!user) {
                    toast.error("Invalid credentials");
                    deleteSessionCookie("accessToken");
                    deleteSessionCookie("refreshToken");
                    return;
                }

                dispatch(login(user));
                toast.success("Logged in successfully");
                navigate("/dashboard");
            } catch (error) {
                toast.error("Invalid credentials");
            } finally {
                setSubmitting(false);
            }
        },
    });

    return { formik, isPending };
}